// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"289":"administration","809":"account"}[chunkId] || chunkId) + "." + {"289":"cdb55018","496":"33b48e01","513":"178aaa65","809":"2bddcfd1"}[chunkId] + ".chunk.js";
};